/* eslint-disable no-useless-catch */
import axios from 'axios';

export async function getPreSignedURL(claimNumber, documents, bucket) {
  const requestBody = {
    query: `
    mutation {
      getPreSignedURL(getPreSignedURLInput: {
        claimNumber: "${claimNumber}",documents:[{extension:"${documents[0].extension}",name:"${documents[0].name}",type:"${documents[0].type}"}], bucket: "${bucket}"})
    }`,
    queryName: 'get_presigned_URLs',
  };
  const response = await axios.post('/api', requestBody);
  return response.data.data;
}

export async function getDocument(claimNumber, bucket) {
  const requestBody = {
    query: `
    mutation {
      getDocument(getDocumentInput: {
        bucket:"${bucket}",claimNumber:"${claimNumber}"})
    }`,
    queryName: 'get_document',
  };
  const response = await axios.post('/api', requestBody);
  return response.data.data;
}

export async function deleteS3File(bucket, claimNumber, fileType, fileName) {
  const requestBody = {
    query: `
    mutation {
      deleteS3File(s3FileDeleteInput: {
        bucket:"${bucket}",claimNumber:"${claimNumber}",fileType:"${fileType}",fileName:"${fileName}"})
    }`,
    queryName: 'delete_S3_file',
  };
  const response = await axios.post('/api', requestBody);
  return response.data.data;
}

export async function fetchAudaTargetImages(vehicleType) {
  const requestBody = {
    query: `
    mutation {
      fetchAudaTargetImages(audaTargetInput: {
        vehicleType: "${vehicleType}"})
    }`,
    queryName: 'fetch_auda_target_images',
  };
  const response = await axios.post('/api', requestBody);
  return response.data;
}
